import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MicrosoftTeamsAutoAttendant } from '../../../shared/models/generated/ziroModels';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class MicrosoftAutoAttendantsSearchResource {
  private http = inject(HttpClient);

  search(tenantId: string, query: string): Observable<MicrosoftTeamsAutoAttendant[]> {
    return this.http.get<MicrosoftTeamsAutoAttendant[]>(
      `/services/microsoft/auto-attendant-management/tenants/${tenantId}/auto-attendants/search?displayName=${encodeURIComponent(query)}`,
    );
  }
}
